<enhanced-help componentName="mission-objectives-list" [compact]="true">
</enhanced-help>
<div *ngIf="objectives != null">
    <table class="table">
        <thead>
            <tr>
                <th style="width: 30%">Name</th>
                <th>
                    <div class="checkbox pull-right" style="margin: 0">
                        <mat-slide-toggle 
                            [(ngModel)]="showArchived"
                            [ngModelOptions]="{ standalone: true }">
                            Show archived mission objectives?
                        </mat-slide-toggle>
                    </div>
                </th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let objective of objectives">
                <tr *ngIf="showArchived || !objective.archived" class="data">
                    <td>
                        <editable
                            *ngIf="!isReadOnlyAdmin"
                            [initialContext]="{name: objective.name, objectiveId: objective.id}"
                            [confirmationButtons]="true"
                            [updateFn]="updateObjectiveName"
                            [disabled]="working"
                        >
                            <ng-template viewMode>
                                {{ objective.name }}
                            </ng-template>
                            <ng-template editMode let-context="context">
                                <input
                                    type="text"
                                    [(ngModel)]="context.name"
                                    class="form-control"
                                    editableOnEnter
                                />
                            </ng-template>
                        </editable>
                        <div *ngIf="isReadOnlyAdmin">
                            {{ objective.name }}
                        </div>
                    </td>
                    <td class="actions">
                        <ng-container *ngIf="!isReadOnlyAdmin">
                            <button
                                *ngIf="!objective.archived"
                                type="button"
                                class="btn btn-tertiary"
                                (click)="archiveObjective(objective)"
                                [disabled]="working"
                                tooltip="Archive"
                                placement="left"
                            >
                                <span class="fal fa-eye-slash"></span>
                            </button>

                            <button
                                *ngIf="objective.archived"
                                type="button"
                                class="btn btn-tertiary"
                                (click)="unArchiveObjective(objective)"
                                [disabled]="working"
                                tooltip="Unarchive"
                                placement="left"
                            >
                                <span class="fal fa-eye"></span>
                            </button>
                        </ng-container>
                    </td>
                </tr>
            </ng-container>
        </tbody>
    </table>
</div>
<div>
    <form (submit)="addObjective()" [formGroup]="createFormGroup">
        <div class="input-group">
            <input
                class="form-control"
                formControlName="name"
                placeholder="Enter the name of the new objective here"
            />
            <span class="input-group-btn">
                <button
                    type="submit"
                    class="btn btn-primary"
                    [disabled]="
                        working || createFormGroup.invalid || isReadOnlyAdmin
                    "
                >
                    Add
                </button>
            </span>
        </div>
    </form>
</div>
